
export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/cf82de00b6f7985ec428633513633f30.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/40"></div>
      
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <div className="inline-block mb-6 px-6 py-2 bg-orange-500 rounded-full">
          <span className="text-white font-bold text-sm tracking-wider">CLASS OF 2029</span>
        </div>
        
        <h1 className="text-6xl md:text-8xl font-black text-white mb-4 tracking-tight">
          JAZZLYN VASSILATOS
        </h1>
        
        <div className="flex items-center justify-center gap-4 mb-6">
          <div className="h-1 w-16 bg-orange-500"></div>
          <p className="text-2xl md:text-3xl font-bold text-orange-400">LIBERO</p>
          <div className="h-1 w-16 bg-orange-500"></div>
        </div>
        
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
          Passionate volleyball athlete with explosive power, strategic court vision, and unwavering dedication to excellence
        </p>
        
        <div className="flex flex-wrap items-center justify-center gap-6 text-white">
          <div className="flex items-center gap-2">
            <i className="ri-trophy-fill text-3xl text-yellow-400"></i>
            <div className="text-left">
              <div className="text-sm text-white/70">Height</div>
              <div className="text-xl font-bold">5'3"</div>
            </div>
          </div>
          
          <div className="h-12 w-px bg-white/30"></div>
          
          <div className="flex items-center gap-2">
            <i className="ri-arrow-up-line text-3xl text-orange-400"></i>
            <div className="text-left">
              <div className="text-sm text-white/70">Vertical Jump</div>
              <div className="text-xl font-bold">24"</div>
            </div>
          </div>
          
          <div className="h-12 w-px bg-white/30"></div>
          
          <div className="flex items-center gap-2">
            <i className="ri-book-open-fill text-3xl text-green-400"></i>
            <div className="text-left">
              <div className="text-sm text-white/70">GPA</div>
              <div className="text-xl font-bold">3.4</div>
            </div>
          </div>
        </div>
        
        <div className="mt-12">
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg rounded-full transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            CONTACT ME
          </button>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/70"></i>
      </div>
    </section>
  );
}
